import { render, staticRenderFns } from "./MonthItem.vue?vue&type=template&id=319f9f92"
import script from "./MonthItem.ts?vue&type=script&lang=ts&external"
export * from "./MonthItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports